import React, { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';
import APIList from '../../../../http/ApiList';
import { Button } from 'antd';
import { Loading } from '@meteor/frontend-core';

const DisplayCabinetChart: React.FC<any> = (props) => {
  const { authInfo, globalEvent, setGlobalEvent, color } = useContext(AppContext);
  const { property } = props;
  const [chartLoading, setChartLoading] = useState<any>(false);
  const [componentLoading, setComponentLoading] = useState(false);
  const [chartData, setChartData] = useState<any>(null);
  const rootRef: any = useRef(null);
  const theme = {
    token: {
      colorPrimary: color.primaryColor,
      colorSuccess: color.successColor,
      colorWarning: color.warningColor,
      colorError: color.errorColor,
      colorInfo: color.infoColor,
      colorLink: color.primaryColor,
    },
  };

  const getChartData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setChartData(res.data);
        setTimeout(() => {
          setChartLoading(false);
        }, 100);
      });
  };

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      (property.dataSource &&
        property.dataSource.triggerEvent &&
        property.dataSource.triggerEvent.find((triggerEvent) => {
          return triggerEvent.event === globalEvent.eventType;
        })) ||
      globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT
    ) {
      if (globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT) {
        setComponentLoading(true);
      }
      setTimeout(() => {
        setComponentLoading(false);
      }, 500);

      setTimeout(() => {
        setChartLoading(true);
        setTimeout(() => {
          getChartData(globalEvent);
        }, 500);
      }, 600);
    }
  }, [globalEvent]);

  const setCabinet = () => {
    if (chartData) {
      const padding = 24;
      const scaleX = (rootRef.current.clientWidth - padding) / chartData.cabinetWidth;
      const scaleY = (rootRef.current.clientHeight - padding) / (chartData.cabinetColumnHeight * chartData.cabinetColumnCount);
      return (
        <>
          {/* <Button type="primary" className="edit-btn" style={{ position: 'absolute', right: 6, top: 6 }}>
            編輯
          </Button> */}
          <div style={{ zoom: scaleX > scaleY ? scaleY : scaleX }}>
            {new Array(chartData.cabinetColumnCount).fill(0).map((_, index) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    width: chartData.cabinetWidth,
                    height: chartData.cabinetColumnHeight,
                    borderTop: index === 0 ? '1px solid #aaa' : 'none',
                    borderRight: '1px solid #aaa',
                    borderBottom: '1px solid #aaa',
                    borderLeft: '1px solid #aaa',
                    overflow: 'hidden',
                  }}
                >
                  {chartData.goods && chartData.goods[index] && chartData.goods[index].length > 0 ? (
                    chartData.goods[index].map((data, i) => {
                      return (
                        <div
                          draggable="true"
                          style={{
                            display: 'inline-block',
                            width: data[0],
                            height: '100%',
                            background: data[4] || 'white',
                            verticalAlign: 'text-bottom',
                            paddingRight: chartData.goodsSpace || 0,
                            flexGrow: 0,
                            flexShrink: 0,
                            flex: '0 0 auto',
                            paddingBottom: 2,
                          }}
                        >
                          <div
                            className="goods-background"
                            style={{
                              height: '100%',
                              backgroundImage: `url(/assets/shelves/resized_${data[3]}_image1.jpg)`,
                            }}
                          ></div>
                        </div>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          </div>
        </>
      );
    }
    return <></>;
  };

  return (
    <>
      {!componentLoading ? <></> : <Loading theme={theme} fixed={false} />}
      <a
        ref={rootRef}
        style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        className="display-cabinet-chart"
      >
        {chartLoading ? <Loading theme={theme} style={{ background: 'rgba(255, 255, 255, 0.5)' }} fixed={false} /> : <></>}
        {setCabinet()}
      </a>
    </>
  );
};

export default DisplayCabinetChart;
